/* BIA motion. IntersectionObserver + rAF parallax, no libraries.
   Degrades fully: without JS everything is visible via html:not(.js) rules. */
(function () {
  'use strict';
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function once(el, k) { if (!el) return false; var d = 'bia' + k; if (el.dataset[d] === '1') return false; el.dataset[d] = '1'; return true; }

  function reveal(root) {
    var els = qa('[data-reveal]:not([data-seen])', root);
    if (!els.length) return;
    if (RM.matches || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.dataset.seen = '1'; e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    els.forEach(function (e) { e.dataset.seen = '1'; io.observe(e); });
  }

  function header() {
    var h = document.querySelector('.hdr');
    if (!h || !once(h, 'Hdr')) return;
    var hero = document.querySelector('.hero, .cine');
    var t = hero ? Math.max(120, hero.offsetHeight * 0.55) : 40;
    var tick = false;
    function run() {
      tick = false;
      var y = window.pageYOffset || document.documentElement.scrollTop;
      h.classList.toggle('is-solid', y > t);
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true });
    window.addEventListener('resize', function () { t = hero ? Math.max(120, hero.offsetHeight * 0.55) : 40; run(); }, { passive: true });
    run();
  }

  function parallax() {
    if (RM.matches) return;
    var items = qa('.p-slow');
    if (!items.length || window.innerWidth < 901) return;
    var tick = false;
    function run() {
      tick = false;
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * -18).toFixed(2) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  function boot() { reveal(document); header(); parallax(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
